import React from "react";
import "./App.css";
import SpyGameCreator from "./components/SpyGameCreator";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>I Spy</h1>
      </header>
      <SpyGameCreator />
    </div>
  );
}

export default App;
